import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    Carousel,
    PageSection,
    SectionTitle,
    MarkdownContent,
} from 'wanderu-components';

import styles from './AboutUsCarouselSection.scss';
import aboutUsStyles from '../AboutUs/AboutUs.scss';

const propTypes = {
    buttonLabel: PropTypes.string,
    buttonUrl: PropTypes.string,
    carouselData: PropTypes.arrayOf(PropTypes.element).isRequired,
    description: PropTypes.string,
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    carouselClassName: PropTypes.string,
    layoutClassName: PropTypes.string,
    descriptionClassName: PropTypes.string,
    subheaderImage: PropTypes.string,
    showHints: PropTypes.bool,
};

function AboutUsCarouselSection(props) {
    const {
        buttonLabel = '',
        buttonUrl = '',
        carouselData,
        description = '',
        title,
        label,
        className = '',
        carouselClassName = '',
        layoutClassName = '',
        descriptionClassName = '',
        subheaderImage = '',
        showHints = false,
    } = props;

    return (
        <PageSection
            aria-labelledby={label}
            className={className}
            layoutClassName={`${styles.layout} ${layoutClassName}`}
        >
            <SectionTitle id={label}>
                {title}
            </SectionTitle>
            {!!description && (
                <MarkdownContent className={`${styles.description} ${descriptionClassName}`}>
                    {description}
                </MarkdownContent>
            )}
            {!!subheaderImage && (
                <img
                    alt=""
                    className={aboutUsStyles.subheaderImage}
                    src={subheaderImage}
                />
            )}
            <div className={`${carouselClassName} ${styles.carouselContainer}`}>
                <Carousel
                    activeIndicatorStyle={styles.carouselIndicator}
                    className={styles.carousel}
                    showHints={showHints}
                    autoplay
                    wrap
                >
                    {carouselData}
                </Carousel>
            </div>
            {!!buttonUrl && (
                <A
                    className={aboutUsStyles.aboutUsButton}
                    href={buttonUrl}
                    native
                >
                    {buttonLabel}
                </A>
            )}
        </PageSection>
    );
}

AboutUsCarouselSection.propTypes = propTypes;

export default AboutUsCarouselSection;
